import * as React from 'react';
import './rangeSlider.css';
import { useTheme } from 'styled-components/macro';

type Props = {
  handleChange: any;
  value: any;
  min?: number;
  max?: number;
};

const genSlideStyle = (value: number, min: number, max: number) => {
  // Prevent division by zero if min and max are the same
  const range = max - min;
  if (range === 0) {
    return {
      point: { left: '0%' },
      range: { width: '0%' },
    };
  }

  // Calculate the value's position as a percentage of the total range
  const percentage = ((value - min) / range) * 100;

  return {
    point: {
      // The thumb's offset should also be based on the percentage
      left: `calc(${percentage}% - ${8 + (percentage / 100) * 8}px)`,
    },
    range: {
      width: `${percentage}%`,
    },
  };
};
export const RangeSlider = ({
  handleChange,
  value = 1,
  min = 0,
  max = 5,
}: Props) => {
  const themes = useTheme();
  const slideStyle = genSlideStyle(value, min, max);

  return (
    <div className='range'>
      <span
        className='range-value'
        style={{
          ...slideStyle.range,
          backgroundColor: themes.colors.primary[100],
        }}
      />
      <span className='circle' style={slideStyle.point} />
      <input
        className='range-slide'
        name='range'
        type='range'
        min={min}
        max={max}
        value={value}
        step={0.1}
        onChange={(e: any) => {
          handleChange(e.target.value);
        }}
      />
    </div>
  );
};
